import { Component } from '@angular/core';

@Component({
  selector: 'app-report-subscription-page',
  templateUrl: './report-subscription-page.component.html',
  styleUrl: './report-subscription-page.component.scss'
})
export class ReportSubscriptionPageComponent {

  contactSales(){
    window.location.href = 'mailto:sales@thekredible.in';
  }
}
